import { render, staticRenderFns } from "./HistoryReport.vue?vue&type=template&id=23176588&scoped=true"
import script from "./HistoryReport.vue?vue&type=script&lang=js"
export * from "./HistoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23176588",
  null
  
)

export default component.exports